import React, { useEffect, useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import DataTable from "../components/DataTable";
import { Badge } from "../components/ui/badge";
import { formatIDR, formatDate } from "../lib/format";

export default function Guarantors() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/guarantors").then((r) => setData(r.data)).finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- load once on mount

  return (
    <div className="p-8 max-w-[1600px] mx-auto" data-testid="guarantors-page">
      <PageHeader title="Guarantor" subtitle={`${data.length} guarantor aktif`} />
      {loading ? <div className="text-sm text-muted-foreground">Memuat…</div> : (
        <DataTable
          testId="guarantors-table"
          searchKeys={["guarantor_id", "name"]}
          columns={[
            { header: "Guarantor ID", cell: (r) => <span className="mono">{r.guarantor_id}</span> },
            { header: "Nama", cell: (r) => <span className="font-medium">{r.name}</span> },
            { header: "Tipe", key: "guarantor_type" },
            { header: "Guarantee Amount", cell: (r) => formatIDR(r.guarantee_amount, { compact: true }), align: "right" },
            { header: "Expiry", cell: (r) => {
              const exp = new Date(r.expiry_date);
              const expired = exp < new Date();
              return <span className={`mono text-xs ${expired ? "text-[#D0021B] font-bold" : ""}`}>{formatDate(r.expiry_date)}{expired ? " (EXP)" : ""}</span>;
            } },
            { header: "Fasilitas", cell: (r) => (
              <div className="flex flex-wrap gap-1">
                {(r.facility_ids || []).slice(0, 3).map((fid) => <Badge key={fid} variant="outline" className="mono text-[10px]">{fid}</Badge>)}
                {r.facility_ids?.length > 3 && <span className="text-xs text-muted-foreground">+{r.facility_ids.length - 3}</span>}
              </div>
            ) },
          ]}
          data={data}
        />
      )}
    </div>
  );
}
